import {NgModule} from "@angular/core";
import {ConfirmationDialogComponent} from "@app/commons/confirmation-dialog/confirmation-dialog.component";
import {CommonModule} from "@angular/common";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";

@NgModule({
    declarations:[ConfirmationDialogComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        MatDialogModule
    ],
    exports:[]
})

export class ConfirmationDialogModule {}
